/**
 * Get all currently active button filters
 *
 * @author rafhun <rafhun@cubetech.ch>
 *
 * @param {HTMLElement} parent
 * @returns string|false
 */
export function getButtonFilters(parent) {
    // Button filters: only active buttons have been selected (queried by `.active` class), so every button is added as filter.
    const buttonFilters = parent.querySelectorAll('[data-ct-filter="button"].active');

    if (buttonFilters) {
        const filters = {};
        buttonFilters.forEach((filter) => {
            // `filter.dataset` is an object with the keys `ctFilterKey` and `ctFilterValue` (maybe also others, contains the names and values of all data attributes)
            const { ctFilterKey, ctFilterValue } = filter.dataset;
            filters[ctFilterKey] = filters[ctFilterKey] || [];
            filters[ctFilterKey] = filters[ctFilterKey].concat(ctFilterValue);
        });

        // Now we create a query string out of the given filters object
        const paramString = new URLSearchParams(filters).toString();

        if (paramString !== '') {
            return paramString;
        }
    }

    return false;
}
